export default "__VITE_ASSET__Cr7FU0A$__"